import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AccountCard from "../../stories/cards/AccountCard";
import { useMediaQuery } from "react-responsive";

function VerifyAccount() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 991 });
  useEffect(() => {
    localStorage.setItem("isLoggedIn", true);
  },[]);

  return (
    <div className="verify-card-wrapper container-fluid">
      <div className="row">
        <div className={`col-md-12 ${isMobile ? "mx-0" : "mx-5"}`}>
          <h3 className="ageo-semibold">Select a verification option</h3>
          <p>
            Please verify your account by choosing one of the options below
          </p>

          <div className="d-flex flex-column verify-buttons">
            <button
              className="btn btn-green mb-4"
              onClick={() => {
                localStorage.setItem("isLoggedIn", true);
                localStorage.setItem("isPkbLive", true);
                navigate("/register-kit", { replace: true });
              }}
            >
              Verify account + I have a test
            </button>

            <button
              className="btn btn-white"
              onClick={() => {
                localStorage.setItem("isLoggedIn", true);
                localStorage.setItem("isPkbLive", true);
                navigate("/", { replace: true });
              }}
            >
              Verify account + I don’t have a test
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyAccount;
